import banigualdad from "./Banigualdad";
import viasChile from "./ViasChile";
import segurosRipley from "./SegurosRipley";
import defaultTasks from "./base";

export const TASK_TYPES = [banigualdad, viasChile, segurosRipley, defaultTasks];
